(function ($) {

    var timeCounterInit = function () {

        $('[data-time-counter]').each(function (i, el) {

            var counterExpiryDateTime = moment.tz(el.dataset.timeCounter, el.dataset.timeZone);

            $(el).countdown(counterExpiryDateTime.toDate()).on('update.countdown', function (event) {
                
                var format = el.dataset.timeFormat || '%-Dd : %-Hh : %Mm : %Ss';  // example 0d : 7h : 11m : 11s
                $(el).html(event.strftime(format));

            }).on('finish.countdown', function (event) {

            });
        });

    }

    if (window.TimeCounterInit === undefined) {
        window.TimeCounterInit = timeCounterInit;
    }

    window.TimeCounterInit();

})(jQuery);